export const DAY_OFFSET = 1;
export const MAX_DAYS = 999;

/*
FYI: We chose the date '2006-01-01' because the year starts on a Sunday. 
We use the beginning of this year as a reference point to simulate 
a list of days. This way, the user perceives it as a regular list 
of days, while we don’t have to reinvent our solution but instead 
leverage an existing one
*/
export const INITIAL_DATE = '2006-01-01';
